import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 21.977a1.5 1.5 0 0 1-2.552 1.07l-3.641-3.58a106.71 106.71 0 0 1-9.388-.265 3.5 3.5 0 0 1-3.235-3.18A51.28 51.28 0 0 1 1 11.5c0-1.32.04-2.478.12-3.473a3.5 3.5 0 0 1 3.24-3.212c2.96-.21 5.517-.315 7.672-.315 2.15 0 4.686.105 7.61.314a3.5 3.5 0 0 1 3.238 3.211c.08.996.12 2.154.12 3.475 0 1.64-.061 3.148-.184 4.527A3.5 3.5 0 0 1 20 19.152v2.825Zm-1-3.265a.5.5 0 0 1 .463-.498c1.27-.093 2.248-1.055 2.357-2.275.12-1.349.18-2.828.18-4.439 0-1.296-.04-2.428-.117-3.395a2.5 2.5 0 0 0-2.313-2.294c-2.901-.207-5.414-.311-7.538-.311-2.13 0-4.663.104-7.601.313a2.5 2.5 0 0 0-2.315 2.294A43.098 43.098 0 0 0 2 11.5c0 1.608.06 3.086.18 4.433a2.5 2.5 0 0 0 2.31 2.272 105.706 105.706 0 0 0 9.508.259.5.5 0 0 1 .36.143l3.791 3.726a.5.5 0 0 0 .85-.356v-3.265ZM8 12.167a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm5.868-.744a.3.3 0 1 0-.424-.424l-1.89 1.89-.934-.935a.3.3 0 0 0-.424.425l1.146 1.146a.3.3 0 0 0 .424 0l2.102-2.102Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageReadOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageReadOutlined_default = SvgMessageReadOutlined;

export { MessageReadOutlined_default as default };
